import { useQuery } from '@tanstack/react-query';

import { axiosInstance } from '~/services';

import { productKeys } from './keys';

import type { TypeGetSuppliersConsignorResponse } from '~/types/product.types';

const ENDPOINT = '/api-lip/v1/suppliers';

/**
 * [상품관리][상품 등록] 공급사 정보 조회 API
 */
export const fetchSuppliersConsignorCode = async (
  consignorCode: string
): Promise<TypeGetSuppliersConsignorResponse> => {
  const { data } = await axiosInstance.get<TypeGetSuppliersConsignorResponse>(`${ENDPOINT}/${consignorCode}`);
  return data;
};

/**
 * [상품관리][상품 등록] 공급사 정보 조회 Query Hook
 */
export const useGetSuppliersConsignorCodeQuery = ({
  consignorCode,
  enabled = true,
}: {
  consignorCode: string;
  enabled?: boolean;
}) => {
  return useQuery({
    queryKey: productKeys.suppliersConsignorCode(consignorCode),
    queryFn: () => fetchSuppliersConsignorCode(consignorCode),
    enabled: enabled && !!consignorCode,
    staleTime: 1000 * 60 * 30,
  });
};
